import { log, error } from '@/services/Log'

import { goToConfirmation } from '@/services/FramedCheckout/navigationServices'
import allPromisesWithRetries from '@/helpers/allPromisesWithRetries'
import type { StandardOrder } from '@/types/ShopFront/CheckoutStandards'

// TODO: !!WARNING!! finalizePendingOrder needs to be tested
type StandardOrderWithOrderId = StandardOrder & { orderId: string }

export const finalizePendingOrder = async ({ order }: { order: StandardOrderWithOrderId }) => {
  const [
    { getOrderWithPayments },
    { default: Axios },
    { postOrderFlow },
  ] = await allPromisesWithRetries(() => [
    import('@/services/FramedCheckout/orderServices/getOrderWithPayments'),
    import('axios'),
    import('@/services/FramedCheckout/orderServices/postOrderFlow'),
  ])
  try {
    log('from inside payment review and processing')
    log('trying create order ', order.orderId)
    // TODO: Update to V3
    await Axios.post(`/internalapi/v1/checkout/order/${order.orderId}`)
    log('done creating order ', order.orderId)
  } catch (err) {
    if (String(err?.type) !== 'order_finalization_not_required') {
      log('order_finalization_not_required', err)
    }
  } finally {
    log('post transition order update')
    const performPostOrderFlow = async () => {
      try {
        log('log inside post order')
        await postOrderFlow({
          ...order,
        })
      } catch (err) {
        error('Failed to perform post order flow', err)
      }
    }

    const [postTransitionOrder] = await Promise.all([
      getOrderWithPayments({ orderId: order.orderId }),
      performPostOrderFlow(),
    ])

    if (postTransitionOrder?.status !== 'INCOMPLETE') {
      log('postTransitionOrder COMPLETE')
      await goToConfirmation(order.orderId)
      await new Promise((res) => {
        // Safari would continue script execution immediately, causing redirection
        // to cart.php if we don't await here.
        setTimeout(() => {
          res(true)
        }, 10000)
      })
    }
  }
}

export default finalizePendingOrder
